// src/redux/actions/companyCategoryActions.js

import axios from '../../API/axios';
import {
    FETCH_COMPANY_CATEGORIES_REQUEST,
    FETCH_COMPANY_CATEGORIES_SUCCESS,
    FETCH_COMPANY_CATEGORIES_FAILURE,
    SET_SELECTED_COMPANY_CATEGORY,
} from '../types';

export const fetchCompanyCategories = () => async (dispatch) => {
    dispatch({ type: FETCH_COMPANY_CATEGORIES_REQUEST });
    try {
        const response = await axios.get('/MasterData/GetFirmCategoryDDL');
        console.log('Company Categories Response:', response);
        let categories = response.data.responseData.map((val) => {
            return { value: val.id, label: val.name }
        })
        // const categoryList = response.data.responseData.map((val) => ({
        //     value: val.id,
        //     label: val.name,
        // }));

        dispatch({
            type: FETCH_COMPANY_CATEGORIES_SUCCESS,
            payload: categories,
        });
    } catch (error) {
        dispatch({
            type: FETCH_COMPANY_CATEGORIES_FAILURE,
            payload: error.message,
        });
    }
};

// Action to select a specific company category
export const selectCompanyCategory = (categoryId) => ({
    type: SET_SELECTED_COMPANY_CATEGORY,
    payload: categoryId,
});
